
import "./ContactUs.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { contactUsSchema } from "./ContactUsValidation";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { Formik, Form, Field } from "formik";

import Navbar from "components/Navbar/Navbar";
import Loader from "utilities/reusableComponent/Loader/Loader";
import Swal from "sweetalert2";

function ContactUs() {

    // get user token from global state
    const { userInfo } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    // Profile form initial values
    const initialValues = {
        subject: "",
        message: ""
    }
    
    // Handling on Submit form
    const handleOnSubmit = async (values, actions) => {
        setLoading(true);
        const sendMessagePayloads = {
            "user_uid": userInfo.uid,
            "email" : userInfo.email,
            "full_name": `${userInfo.first_name} ${userInfo.last_name}`,
            "subject": `FROM TEACHER: ${values.subject}`,
            "message": values.message,
            "is_dashboard": true
        };
    
        const res = await apiRequest({
          requestType: requestType.sendSupportMessage,
          payload: {
            data: sendMessagePayloads
          }
        });
    
        if (res?.data?.status === 0) {
            setLoading(false);
            actions.resetForm();
            const swalFailedMessage = Swal.mixin({
              customClass: {
                popup: "swal-success-popup",
                confirmButton: "swal-success",
                title: "swal-title",
              },
              buttonsStyling: false,
            });
            swalFailedMessage.fire({
              title: "Message Sended",
              html: `<p class='swal-text-html'>Your support message already sent successfully.</p>`,
              imageWidth: 65,
              imageHeight: 60,
              confirmButtonText: "Ok",
            });
        } else {
            setLoading(false);
            const swalFailedMessage = Swal.mixin({
              customClass: {
                popup: "swal-failed-popup",
                confirmButton: "swal-success",
                title: "swal-title",
              },
              buttonsStyling: false,
            });
            swalFailedMessage.fire({
              title: "Sorry!",
              html: `<p class='swal-text-html'>${res.data.error_message}</p>`,
              imageWidth: 65,
              imageHeight: 60,
              confirmButtonText: "Ok",
            });
        }
    }

  return (
    <>
        <div className="">
            <Navbar />
            <div className="max-w-screen-lg mx-auto">
                <div className="pt-[50px] w-full">
                    <h1 className="font-gluten text-custom-navy font-bold text-4xl">
                        Contact Us
                    </h1>
                    <div className="flex flex-row gap-10 mt-[40px] h-screen">
                        <Formik
                            initialValues= {initialValues}
                            validationSchema= {contactUsSchema}
                            onSubmit={(values, actions) => handleOnSubmit(values, actions)}
                        >
                            {({errors}) => {
                            return (
                                <Form>
                                    <div className="w-[1024px] grid grid-cols-2 gap-y-[50px] gap-x-[25px]">
                                        <div className="col-span-2">
                                            <p className="text-xl mb-2">Subject*</p>
                                            <Field
                                                type="text"
                                                name="subject"
                                                placeholder="Enter subject"
                                                className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[18px] text-form-color placeholder:text-form-placeholder-color"
                                            />
                                            {errors.subject && <small className="text-red-500">{errors.subject}</small>}
                                        </div>
                                        <div className="col-span-2">
                                            <p className="text-xl mb-2">Message*</p>
                                            <Field
                                                type="text"
                                                name="message"
                                                as='textarea'
                                                placeholder="Type message here"
                                                className="h-[150px] rounded-[20px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[18px] text-form-color placeholder:text-form-placeholder-color"
                                            />
                                            {errors.message && (<small className="text-red-500">{errors.message}</small>)}
                                        </div>
                                        <div className=" col-span-2 rounded-[67.491px] py-[20px] mt-[20px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer">
                                            <button type="submit" className="w-full">Send Message</button>
                                        </div>
                                    </div>
                                </Form>
                            )}}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
        {loading && <Loader />}
    </>

  );
}

export default ContactUs;
